import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { VehicleTypeCreateComponent } from '../vehicle-type-create/vehicle-type-create.component';

@Component({
  selector: 'app-vehicle-type-landing',
  standalone: false,
  templateUrl: './vehicle-type-landing.component.html',
  styleUrl: './vehicle-type-landing.component.scss',
})
export class VehicleTypeLandingComponent {
  action_idx: any = null;

  dataList: any[] = [];
  form: FormGroup;

  isSearching: boolean = false;
  showSearchForm: boolean = false;

  searchedDataNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;

  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;

  @Output() onConfirmClicked = new EventEmitter();

  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm;
  }

  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [''],
      from: [''],
      to: [''],
      offset: [''],
    });
    this.search();
  }

  clearSearchFilters() {
    this.form.reset();
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      // location.reload();
      this.search();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {});
  }

  openDeleteConfirmModal(id: number) {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Delete Workflow:??',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.deleteWorkflow(id);
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  createVehicleType(): any {
    let dialogRef = this.dialog.open(VehicleTypeCreateComponent, {
      width: '550px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      disableClose: true,
    });
    return dialogRef;
  }

  viewWorkflow(id: number): any {
    // let dialogRef = this.dialog.open(WorkflowDetailsComponent, {
    //   width: '550px',
    //   backdropClass: 'modal-form-backdrop',
    //   hasBackdrop: true,
    //   panelClass: ['modal-form'],
    //   disableClose: true,
    //   data: { id: id },
    // });
    // return dialogRef;
  }

  deleteWorkflow(id: number): void {
    // this.isLoading = true;
    // this.apiService
    //   .get(`/workflow/delete/${id}`)
    //   .pipe(
    //     finalize(() => {
    //       this.isLoading = false;
    //     })
    //   )
    //   .subscribe({
    //     next: (response: any) => {
    //       if (response) {
    //         this.openSuccessModal('Workflow deleted successfuly');
    //       }
    //     },
    //     error: (error) => {
    //       this.openErrorModal(error?.message);
    //     },
    //   });
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }

  updateLimit() {
    this.currentPage = 1;

    this.page = 0;

    this.search();
  }

  errorFetchingData: boolean = false;

  search() {
    this.dataList = [];
    this.searchedDataNotFound = false;
    this.isSearching = true;
    this.errorFetchingData = false;

    this.pageSize = this.selectedLimit;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    formData.append('offset', this.num);
    formData.append('limit', this.selectedLimit);
    formData.append('name', this.form.get('name')?.value || '');
    formData.append('from', this.form.get('from')?.value || '');
    formData.append('to', this.form.get('to')?.value || '');

    this.apiService
      .post('/vehicle-type/paged', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {
          this.dataList = response.data;

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedDataNotFound = true;
          }
        },
        (error) => {
          this.openErrorModal(error?.message);
          this.errorFetchingData = true;
        }
      );
  }
}
